import fullGradeName from 'district-ui-client/helpers/full-grade-name'
import { DetailedPageWrapper } from 'district-ui-client/components/reporting/detailed-page-wrapper'
import { ChartsAwardsEarnedTrophiesTotals } from 'district-ui-client/components/charts/awards-earned/trophies/totals'
import { not } from 'ember-truth-helpers'
import { t } from 'ember-intl'
import type RexAwardsEarnedRoute from 'district-ui-client/reporting/ui-scope/rex/awards-earned/route'
import { PhosphorIcon } from 'district-ui-client/components/phosphor-icon'
import { Tooltip } from 'district-ui-client/components/tooltip'
import type { TOC } from '@ember/component/template-only'
import RouteTemplate from 'ember-route-template'

interface Signature {
  Args: {
    model: ModelFor<RexAwardsEarnedRoute>
  }
}

export const RexAwardsEarnedRouteTemplate: TOC<Signature> = <template>
  <DetailedPageWrapper @empty={{not @model.awardsEarnedTotals}}>
    {{#each @model.awardsEarnedTotals as |gradeData|}}
      <div class="detailed-chart-wrapper relative">
        <ChartsAwardsEarnedTrophiesTotals
          data-test-awards-earned-trophies-totals
          class="h-full"
          @data={{gradeData}}
          @product={{@model.product}}
          @grade={{fullGradeName gradeData.grade_position}}
          @title={{t "reporting.chartTitles.awardsEarnedTotals.rex"}}
          @yAxisTitle={{t "reporting.chartTitles.awardsEarnedTotals.rex"}}
        />
        <span class="absolute right-0.5 top-0 print:hidden">
          <PhosphorIcon @icon="phosphor-info-fill" class="h-3.5 w-3.5 cursor-pointer text-dusty-black-500" />
          <Tooltip @text={{t "reporting.tooltips.awardsEarnedTotals.rex" htmlSafe=true}} />
        </span>
      </div>
    {{/each}}
  </DetailedPageWrapper>
</template>

export default RouteTemplate(RexAwardsEarnedRouteTemplate)
